type SignInOnboardingExperimentGroup = 'control' | 'treatment';

export type SignInOnboardingExperimentState =
  { status: 'pending' } | { status: SignInOnboardingExperimentGroup };

export function useSignInOnboardingExperiment(): SignInOnboardingExperimentState {
  // The Statsig experiment has ended; keep legacy routing until its replacement is implemented.
  return { status: 'control' };
}
